var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlatinum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "246px",
    height: "223px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#1d4169",
    d: "M 121.5,-0.5 C 122.167,-0.5 122.833,-0.5 123.5,-0.5C 123.5,10.8333 123.5,22.1667 123.5,33.5C 123.5,37.1667 123.5,40.8333 123.5,44.5C 114.709,61.7524 106.709,79.4191 99.5,97.5C 89.1234,91.3114 78.4568,85.6447 67.5,80.5C 85.5,53.5 103.5,26.5 121.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#1479b7",
    d: "M 123.5,-0.5 C 123.833,-0.5 124.167,-0.5 124.5,-0.5C 128.58,7.32884 132.913,14.9955 137.5,22.5C 132.901,26.0816 128.234,29.7483 123.5,33.5C 123.5,22.1667 123.5,10.8333 123.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#0897df",
    d: "M 137.5,22.5 C 140.985,26.7904 143.985,31.457 146.5,36.5C 131.792,43.1315 128.625,53.4648 137,67.5C 144.302,73.047 152.135,73.8803 160.5,70C 162.402,68.2703 164.069,66.437 165.5,64.5C 168.399,67.9516 171.066,71.6183 173.5,75.5C 165.097,84.7416 154.764,87.7416 142.5,84.5C 136.167,71.1667 129.833,57.8333 123.5,44.5C 123.5,40.8333 123.5,37.1667 123.5,33.5C 128.234,29.7483 132.901,26.0816 137.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#01abfb",
    d: "M 146.5,36.5 C 152.8,45.8103 159.134,55.1437 165.5,64.5C 164.069,66.437 162.402,68.2703 160.5,70C 152.135,73.8803 144.302,73.047 137,67.5C 128.625,53.4648 131.792,43.1315 146.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b5e8d",
    d: "M 123.5,44.5 C 129.833,57.8333 136.167,71.1667 142.5,84.5C 143.966,88.2213 145.633,91.888 147.5,95.5C 147.957,96.2975 148.624,96.6309 149.5,96.5C 149.158,97.3382 148.492,97.6716 147.5,97.5C 131.532,89.5357 115.532,89.5357 99.5,97.5C 106.709,79.4191 114.709,61.7524 123.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#0f82c3",
    d: "M 173.5,75.5 C 174.89,76.8993 175.89,78.5659 176.5,80.5C 167.363,85.57 158.363,90.9033 149.5,96.5C 148.624,96.6309 147.957,96.2975 147.5,95.5C 145.633,91.888 143.966,88.2213 142.5,84.5C 154.764,87.7416 165.097,84.7416 173.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#132942",
    d: "M 67.5,80.5 C 78.4568,85.6447 89.1234,91.3114 99.5,97.5C 99.5,98.1667 99.8333,98.5 100.5,98.5C 104.338,105.516 108.672,112.183 113.5,118.5C 116.575,123.643 119.908,128.643 123.5,133.5C 127.192,128.149 130.859,122.815 134.5,117.5C 138.859,111.795 142.859,105.795 146.5,99.5C 147.338,99.1583 147.672,98.4916 147.5,97.5C 148.492,97.6716 149.158,97.3382 149.5,96.5C 158.363,90.9033 167.363,85.57 176.5,80.5C 159.325,106.855 141.659,132.855 123.5,158.5C 104.453,132.784 85.7862,106.784 67.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1174a8",
    d: "M 147.5,97.5 C 147.672,98.4916 147.338,99.1583 146.5,99.5C 146.565,99.0618 146.399,98.7284 146,98.5C 142.676,100.579 139.176,102.246 135.5,103.5C 127.505,102.21 119.505,102.21 111.5,103.5C 107.684,102.091 104.017,100.424 100.5,98.5C 99.8333,98.5 99.5,98.1667 99.5,97.5C 115.532,89.5357 131.532,89.5357 147.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#40aedd",
    d: "M 100.5,98.5 C 104.017,100.424 107.684,102.091 111.5,103.5C 115.109,106.311 119.109,108.645 123.5,110.5C 127.891,108.645 131.891,106.311 135.5,103.5C 139.176,102.246 142.676,100.579 146,98.5C 146.399,98.7284 146.565,99.0618 146.5,99.5C 142.859,105.795 138.859,111.795 134.5,117.5C 133.338,116.322 132.338,115.155 131.5,114C 125.446,112.336 119.446,112.67 113.5,115C 114.167,115.333 114.833,115.667 115.5,116C 114.244,116.417 113.577,117.25 113.5,118.5C 108.672,112.183 104.338,105.516 100.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#188dc5",
    d: "M 135.5,103.5 C 131.891,106.311 127.891,108.645 123.5,110.5C 119.109,108.645 115.109,106.311 111.5,103.5C 119.505,102.21 127.505,102.21 135.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#46c5f7",
    d: "M 134.5,117.5 C 130.859,122.815 127.192,128.149 123.5,133.5C 119.908,128.643 116.575,123.643 113.5,118.5C 113.577,117.25 114.244,116.417 115.5,116C 114.833,115.667 114.167,115.333 113.5,115C 119.446,112.67 125.446,112.336 131.5,114C 132.338,115.155 133.338,116.322 134.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.037
    },
    fill: "#183870",
    d: "M 152.5,139.5 C 153.668,141.885 153.001,143.885 150.5,145.5C 150.167,145.167 149.833,144.833 149.5,144.5C 150.763,142.971 151.763,141.305 152.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#00abff",
    d: "M 132.5,176.5 C 133.525,176.897 133.692,177.563 133,178.5C 132.536,177.906 132.369,177.239 132.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#098dd0",
    d: "M 110.5,203.5 C 109.833,202.167 109.833,202.167 110.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#0889d2",
    d: "M 110.5,203.5 C 111.833,204.167 111.833,204.167 110.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.014
    },
    fill: "#0f6cae",
    d: "M 122.5,222.5 C 123.167,221.167 123.833,221.167 124.5,222.5C 123.833,222.5 123.167,222.5 122.5,222.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.98472887903cf8addd8e5fa9975186a8.svg";
export { ForwardRef as ReactComponent };